export const environment = {
  production: true,
  apiUrl: 'http://aisapi.tia365.com/api/'
};
